// @flow

import { observer } from "mobx-react";
import React from "react";

import AppearanceStore from "app/stores/AppearanceStore";

const mobileBreakpoint = 991;
const maxWidth = 885;
const timeThreshold = 1000;

type Props = {
    onScale: Function
};

@observer
export default class Scaler extends React.Component<Props> {
    timeout: TimeoutID;
    element: ?HTMLDivElement;

    scale = (withoutThreshold: boolean = false) => {
        if (!this.element) return;

        if (this.timeout) clearTimeout(this.timeout);

        const width = this.element.offsetWidth;
        let scale = 1;

        // $FlowFixMe
        if (
            AppearanceStore.embed ||
            document.body.offsetWidth <= mobileBreakpoint
        ) {
            scale = -1;
        } else if (width < maxWidth) {
            scale = width / maxWidth;
        }

        if (withoutThreshold) {
            this.props.onScale(scale);
        } else {
            this.timeout = setTimeout(() => {
                this.props.onScale(scale);
            }, timeThreshold);
        }
    };

    componentDidMount() {
        this.scale(true);
        window.addEventListener("resize", this.scale);
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.scale);
    }

    render() {
        return <div ref={element => (this.element = element)} />;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/Scaler/Scaler.js